<div
  class="behavior-card-wrapper"
  *ngIf="caseDetail.caseBehaviors && caseDetail.caseBehaviors.length > 0">
  <div *ngFor="let behavior of caseDetail?.caseBehaviors" class="with-chart">
    <div class="behavior-card">
      <div
        (click)="toggleBehaviorExpand(behavior)"
        (keydown.enter)="toggleBehaviorExpand(behavior)"
        tabindex="0"
        class="card-header"
        [ngClass]="
          behavior.draft
            ? 'card-header-draft'
            : behavior.statusId === 2
              ? ''
              : 'card-header-complete'
        ">
        <div class="header-left">
          <h3
            class="title"
            [ngClass]="behavior.draft ? 'orange-text' : 'green-text'">
            {{ behavior.behaviorCategoryName }}
          </h3>
          <p class="desc">
            {{ getCaseBehaviourSubTypes(behavior).join(', ') }}
          </p>
        </div>
        <div class="header-right">
          <span *ngIf="!behavior.draft">
            <span>
              {{ behavior.statusId === 1 ? 'Active' : 'Deactivated' }}
              <nz-switch
                [ngModel]="behavior.statusId === 1"
                (ngModelChange)="onActiveInActiveBehavior(behavior, $event)" />
            </span>
            <button
              *ngIf="behavior.isCorrectionNeeded"
              nz-button
              nzType="default"
              class="danger-btn"
              nz-tooltip
              nzTooltipTitle="Correction Needed"
              nzTooltipPlacement="bottom"
              (click)="openCorrectionNeededDrawer(behavior)">
              <svg-icon
                [title]="'Correction Needed'"
                src="/assets/icon/icon-info.svg"
                class="icon s-20"
                aria-label="Info"></svg-icon>
            </button>
          </span>
          <span *ngIf="behavior.draft">
            <!-- cta buttons -->
            <button
              *ngIf="behavior.isCorrectionNeeded"
              nz-button
              nzType="default"
              class="danger-btn"
              nz-tooltip
              nzTooltipTitle="Correction Needed"
              nzTooltipPlacement="bottom"
              (click)="openCorrectionNeededDrawer(behavior)">
              <svg-icon
                [title]="'Correction Needed'"
                src="/assets/icon/icon-info.svg"
                class="icon s-20"
                aria-label="Info"></svg-icon>
            </button>
            <button
              nz-button
              nzType="primary"
              class="draft-btn"
              (click)="editBehavior(behavior)">
              <svg-icon
                [title]="'Edit Behavior'"
                src="/assets/icon/icon-edit.svg"
                class="icon s-20"
                aria-label="Edit"></svg-icon>
            </button>
            <button
              nz-button
              nzType="default"
              class="link-btn"
              (click)="deleteBehavior(behavior)">
              <svg-icon
                [title]="'Delete Behavior'"
                src="/assets/icon/icon-trash.svg"
                class="icon s-20"
                aria-label="Trash"></svg-icon>
            </button>
          </span>
        </div>
      </div>
      <div
        class="card-body"
        [ngClass]="{ overlay: behavior.statusId === 2 }"
        *ngIf="behavior.isExpanded">
        <div class="card-body-wrapper">
          <div class="card-content with-border">
            <nz-descriptions
              [nzColumn]="{ xxl: 2, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }">
              <nz-descriptions-item
                nzTitle="Operational Definition"
                [nzSpan]="2">
                <ng-container
                  *ngIf="behavior.operationalDefinition; else noDefinition">
                  <div class="definition-text">
                    {{ behavior.operationalDefinition | slice: 0 : 200 }}
                    <a
                      *ngIf="behavior.operationalDefinition.length > 200"
                      (click)="
                        showOperationalDefinitionModal(
                          behavior.operationalDefinition
                        )
                      "
                      (keydown.enter)="
                        showOperationalDefinitionModal(
                          behavior.operationalDefinition
                        )
                      "
                      tabindex="0"
                      class="show-more-link">
                      ...Show More
                    </a>
                  </div>
                </ng-container>
                <ng-template #noDefinition
                  >No operational definition has been provided</ng-template
                >
              </nz-descriptions-item>
              <nz-descriptions-item nzTitle="Resource Added">
                <span [ngClass]="getDaysAgoColor(behavior.resourceAddedDate)">{{
                  behavior.resourceAddedDate
                    ? getDaysAgoText(behavior.resourceAddedDate)
                    : 'Not added yet'
                }}</span>
              </nz-descriptions-item>
              <nz-descriptions-item nzTitle="Modified">
                <span [ngClass]="getDaysAgoColor(behavior.modifiedDate)">
                  {{
                    behavior.modifiedDate
                      ? getDaysAgoText(behavior.modifiedDate)
                      : 'Not modified'
                  }}
                </span>
              </nz-descriptions-item>
              <nz-descriptions-item nzTitle="Data last entered" [nzSpan]="2">
                <span
                  [ngClass]="getDaysColorforDataEntry(behavior.dataEnteredDate)"
                  >{{
                    behavior.dataEnteredDate
                      ? getDaysAgoText(behavior.dataEnteredDate)
                      : 'Enter data for this behavior'
                  }}</span
                >
              </nz-descriptions-item>

              <nz-descriptions-item nzTitle="Functions" [nzSpan]="2">
                <span *ngIf="behavior.behaviorFunction.length > 0">
                  {{ getFuncationsName(behavior.behaviorFunction) }}</span
                >
                <span *ngIf="behavior.behaviorFunction.length === 0"
                  >No functions identified</span
                >
              </nz-descriptions-item>
            </nz-descriptions>
          </div>
          <div class="card-content with-cards">
            <div class="sub-card">
              <button
                nz-button
                nzType="link"
                class="link-btn"
                (click)="editBehavior(behavior, true)">
                {{ behaviorDetails | reportLabel | async }}
              </button>
              <p
                class="desc"
                [ngClass]="{
                  'orange-text': behavior.draft,
                  'green-text': !behavior.draft,
                }">
                <ng-container *ngIf="behavior.draft">
                  <svg-icon
                    src="/assets/icon/icon-info-circle-sm.svg"
                    class="icon s-12"
                    aria-label="Info Circle Sm"></svg-icon>
                  Complete {{ behaviorDetails | reportLabel | async }}
                </ng-container>
                <ng-container *ngIf="!behavior.draft">
                  <svg-icon
                    src="/assets/icon/icon-check-circle-sm.svg"
                    class="icon s-12"
                    aria-label="Check Circle Sm"></svg-icon>
                  {{ behaviorDetails | reportLabel | async }} completed
                </ng-container>
              </p>
            </div>
            <div class="sub-card">
              <button
                [disabled]="behavior.draft"
                [class.link-button-disabled]="behavior.draft"
                nz-button
                nzType="link"
                class="link-btn"
                (click)="openAssessmentFbaDrawer(behavior)">
                {{ assessLabel | reportLabel | async }}
              </button>
              <p
                class="desc"
                [ngClass]="{
                  'orange-text':
                    behavior.draft ||
                    behavior.behaviorFunction.length === 0 ||
                    behavior.behaviorAssessmentGraph.length === 0,
                  'green-text':
                    !behavior.draft &&
                    behavior.behaviorFunction.length > 0 &&
                    behavior.behaviorAssessmentGraph.length > 0,
                }">
                <ng-container *ngIf="behavior.draft">
                  <svg-icon
                    src="/assets/icon/icon-info-circle-sm.svg"
                    class="icon s-12"
                    aria-label="Info Circle Sm"></svg-icon>
                  Complete {{ behaviorDetails | reportLabel | async }}
                  first
                </ng-container>
                <ng-container
                  *ngIf="
                    !behavior.draft &&
                    behavior.behaviorFunction.length > 0 &&
                    behavior.behaviorAssessmentGraph.length > 0
                  ">
                  <svg-icon
                    src="/assets/icon/icon-check-circle-sm.svg"
                    class="icon s-12"
                    aria-label="Check Circle Sm"></svg-icon>
                  {{ assessLabel | reportLabel | async }} completed
                </ng-container>
                <ng-container
                  *ngIf="
                    !behavior.draft &&
                    (behavior.behaviorFunction.length === 0 ||
                      behavior.behaviorAssessmentGraph.length === 0)
                  ">
                  <svg-icon
                    src="/assets/icon/icon-info-circle-sm.svg"
                    class="icon s-12"
                    aria-label="Info Circle Sm"></svg-icon>
                  {{ assessLabel | reportLabel | async }} needed
                </ng-container>
              </p>
            </div>
            <div class="sub-card">
              <button
                [disabled]="behavior.draft"
                [class.link-button-disabled]="behavior.draft"
                nz-button
                nzType="link"
                class="link-btn"
                (click)="openManageBehaviorStrategiesDrawer(behavior)">
                Strategies
              </button>
              <p
                class="desc"
                [ngClass]="!behavior.appliedStrategyCount ? '' : 'green-text'">
                <svg-icon
                  [src]="
                    behavior.appliedStrategyCount &&
                    behavior.appliedStrategyCount > 0
                      ? '/assets/icon/icon-check-circle-sm.svg'
                      : '/assets/icon/icon-info-circle-sm.svg'
                  "
                  class="icon s-12"
                  aria-label="Strategy Status">
                </svg-icon>
                {{
                  behavior.appliedStrategyCount &&
                  behavior.appliedStrategyCount > 0
                    ? behavior.appliedStrategyCount === 1
                      ? '1 strategy has been added'
                      : behavior.appliedStrategyCount +
                        ' strategies have been added'
                    : 'No strategy has been added'
                }}
              </p>
            </div>
            <div class="sub-card">
              <button
                nz-button
                nzType="link"
                class="link-btn"
                (click)="openDataDrawer(behavior)">
                Data
              </button>
              <p
                class="desc"
                [ngClass]="getDaysColorforDataEntry(behavior.dataEnteredDate)">
                <svg-icon
                  [src]="
                    behavior.dataEnteredDate
                      ? '/assets/icon/icon-check-circle-sm.svg'
                      : '/assets/icon/icon-info-circle-sm.svg'
                  "
                  aria-label="Icon"></svg-icon>
                <span>{{
                  behavior.dataEnteredDate
                    ? 'Data Last Entered: ' +
                      (behavior.dataEnteredDate | userDate: 'MM/dd/yyyy')
                    : 'Enter data for Behavior'
                }}</span>
              </p>
            </div>

            <!-- pass block class to display in full width -->
            <div
              class="sub-card block"
              *ngIf="
                behavior.behaviorFunction.length === 0 ||
                behavior.behaviorAssessmentGraph.length === 0 ||
                behavior.appliedStrategyCount === 0 ||
                behavior.draft
              ">
              <p
                class="desc"
                [ngClass]="{
                  'red-text': !behavior.draft,
                  'orange-text': behavior.draft,
                }">
                <svg-icon
                  [src]="
                    behavior.draft
                      ? '/assets/icon/icon-info-circle-sm.svg'
                      : '/assets/icon/icon-warning-circle-sm.svg'
                  "
                  class="icon s-12"
                  aria-label="Icon">
                </svg-icon>
                <ng-container
                  *ngIf="
                    behavior.behaviorFunction.length === 0 ||
                    behavior.behaviorAssessmentGraph.length === 0 ||
                    behavior.appliedStrategyCount === 0 ||
                    behavior.draft
                  ">
                  <div class="green-text resume-button-container">
                    <span>
                      Please complete the
                      {{
                        getDynamicLabel(behavior) | reportLabel | async
                      }}</span
                    >

                    <button
                      nz-button
                      nzType="default"
                      (click)="
                        resumeProcess(getDynamicLabel(behavior), behavior)
                      ">
                      Resume
                    </button>
                  </div>
                </ng-container>
              </p>
            </div>
          </div>
        </div>

        <div class="card-body-wrapper">
          <app-screener-results-graph
            *ngIf="
              behavior.behaviorAssessmentGraph.length > 0 &&
              behavior.behaviorFunction.length > 0
            "
            [graphData]="behavior.behaviorAssessmentGraph"
            [chartId]="'list-chart_' + generateRandomId"
            (chartImage)="onChartImageGenerated($event, behavior)" />
          <div
            class="chart-container"
            *ngIf="
              behavior.behaviorAssessmentGraph.length === 0 ||
              behavior.behaviorFunction.length === 0
            ">
            <!-- Chart -->
            <app-screener-results-graph
              [class.blurred]="showOverlay"
              [graphData]="[]"
              [chartId]="'list-chart_' + generateRandomId">
            </app-screener-results-graph>

            <!-- Overlay -->
            <div class="chart-overlay" *ngIf="showOverlay">
              <div class="overlay-content">
                <span class="lock" *ngIf="showLock"
                  ><svg-icon
                    src="/assets/icon/icon-lock.svg"
                    class="icon s-20"
                    aria-label="Lock"></svg-icon
                ></span>
                <span>
                  Please complete the
                  {{ getDynamicLabel(behavior) | reportLabel | async }}</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="caseDetail.caseBehaviors && caseDetail.caseBehaviors.length === 0">
    <app-no-data title="No Behavior" desc="No Behavior Defined"></app-no-data>
  </div>
  <app-confirm-dialog
    [isVisible]="isDeleteDialogOpen"
    title="Delete Behavior"
    message="Are you sure you want to delete the Behavior?"
    [iconSrc]="'/assets/icon/icon-trash-red.svg'"
    [iconColor]="'red'"
    [cancelText]="'Cancel'"
    [confirmText]="'Delete'"
    [loading]="isDeleting"
    (confirmed)="handleDelete()"
    (cancelled)="handleCancel()"
    (closed)="handleCancel()">
  </app-confirm-dialog>

  <ng-template #drawerTitleTpl>
    <div class="drawer-title-wrapper">
      <div class="back-button">
        <button nz-button nzType="default" type="button">
          <svg-icon
            src="/assets/icon/icon-arrow.svg"
            class="icon s-20"
            aria-label="Arrow"></svg-icon>
        </button>
      </div>
      <div>
        <h3 class="ant-drawer-title">Behavior Screener</h3>
        <nz-breadcrumb nzSeparator=">">
          <nz-breadcrumb-item>
            <span> {{ caseDetail.student.firstName }}'s </span>
          </nz-breadcrumb-item>
          <nz-breadcrumb-item
            (click)="closeFBADrawer()"
            (keydown.enter)="closeFBADrawer()">
            <a tabindex="0">Assessment FBA</a>
          </nz-breadcrumb-item>
        </nz-breadcrumb>
      </div>
    </div>
  </ng-template>

  <ng-template #drawerBehaviorTitleTpl>
    <div class="drawer-title-wrapper">
      <div class="back-button">
        <button nz-button nzType="default" type="button">
          <svg-icon
            src="/assets/icon/icon-arrow.svg"
            class="icon s-20"
            aria-label="Arrow"></svg-icon>
        </button>
      </div>
      <div>
        <h3 class="ant-drawer-title">Define Behavior</h3>
        <nz-breadcrumb nzSeparator=">">
          <nz-breadcrumb-item>
            <span> {{ caseDetail.student.firstName }}'s </span>
          </nz-breadcrumb-item>
          <nz-breadcrumb-item
            (click)="closeBehaviorDrawer()"
            (keydown.enter)="closeBehaviorDrawer()">
            <a tabindex="0">Define Behavior</a>
          </nz-breadcrumb-item>
        </nz-breadcrumb>
      </div>
    </div>
  </ng-template>

  <ng-template #drawerTitleBehaviorStrategies>
    <div class="drawer-title-wrapper">
      <div class="back-button">
        <button nz-button nzType="default" type="button">
          <svg-icon
            src="/assets/icon/icon-arrow.svg"
            class="icon s-20"
            aria-label="Arrow"></svg-icon>
        </button>
      </div>
      <div>
        <h3 class="ant-drawer-title">Manage Behavior Strategies</h3>
        <nz-breadcrumb nzSeparator=">">
          <nz-breadcrumb-item>
            <span>
              <span> {{ caseDetail.student.firstName }}'s </span>
            </span>
          </nz-breadcrumb-item>
          <nz-breadcrumb-item
            (click)="closeManageBehaviorStrategiesDrawer()"
            (keydown.enter)="closeManageBehaviorStrategiesDrawer()">
            <a tabindex="0">Strategies</a>
          </nz-breadcrumb-item>
        </nz-breadcrumb>
      </div>
    </div>
  </ng-template>
</div>

<nz-modal
  [(nzVisible)]="isDefinitionModalVisible"
  [nzTitle]="modalHeaderTemplate"
  (nzOnCancel)="handleModalClose()"
  nzWidth="600px">
  <ng-template #modalHeaderTemplate>
    <div class="modal-header">
      <div class="modal-icon">
        <svg-icon
          src="/assets/icon/icon-info.svg"
          class="icon s-20"
          aria-label="Info"></svg-icon>
      </div>
      <h3 class="ant-modal-title">Operational Definition</h3>
      <svg-icon
        src="/assets/icon/icon-modal-circle.svg"
        class="icon s-20 circle-pattern"
        aria-label="Modal Circle"></svg-icon>
    </div>
  </ng-template>

  <ng-container *nzModalContent>
    <p class="detail-list">{{ selectedDefinition }}</p>
  </ng-container>

  <div *nzModalFooter>
    <button nz-button nzType="primary" (click)="handleModalClose()">
      Close
    </button>
  </div>
</nz-modal>

<ng-template #correctionNeededTpl>
  <app-drawer-header
    [title]="(fidelityCheckLabel | reportLabel | async) ?? ''"
    [subtitle]="'Correction Needed'"
    breadcrumbText="{{ caseDetail.student.firstName }}'s"
    (drawerClose)="closeCorrectionNeededDrawer()">
  </app-drawer-header>
</ng-template>
<ng-template #drawerTitleData>
  <app-drawer-header
    [title]="'Data'"
    subtitle="''"
    [breadcrumbText]="''"
    (drawerClose)="closeDataDrawer()">
  </app-drawer-header>
</ng-template>
